import { Col, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { localize } from '../../helpers';
import Button from '../button/button';
import { getPrintForm } from './action';
import './index.scss';
import { IPrintForm2Props } from './type';

const PrintForm2 = (props: IPrintForm2Props) => {
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 700);

    useEffect(() => {
        if (props.isOpen) {
            openModal();
        }
    }, [props.isOpen]);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.contentRect && entry.contentRect.width) {
                    setIsMobile(entry.contentRect.width < 700);
                }
            }
        });

        resizeObserver.observe(document.documentElement);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    const closeModal = () => {
        Modal.destroyAll();
    };

    const print = () => {
        const iframe = document.getElementById('print-data');
        iframe?.contentWindow?.print();
    };

    const openModal = async () => {
        setLoading(true);

        // const isVerified = await executeRecaptcha('printForm');
        // if (!isVerified) {
        //     return;
        // }

        getPrintForm(props.apiUrl, props.params, props.isPost, props.tokenStr)
            .then((data) => {
                const blob = new Blob([data.data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);

                if (isMobile) {
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'file.pdf');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else {
                    Modal.info({
                        wrapClassName: 'print-modal',
                        icon: null,
                        content: props.renderContent ? (
                            props.renderContent(data, print, closeModal)
                        ) : (
                            <div className="w-100 h-100 text-center d-flex">
                                <iframe
                                    id="print-data"
                                    width="100%"
                                    height="100%"
                                    // height={`${window.innerHeight * 0.7}px`}
                                    src={url}
                                />
                            </div>
                        ),
                        footer: props.renderFooter ? (
                            props.renderFooter(data, print, closeModal)
                        ) : (
                            <Row
                                justify="end"
                                gutter={15}
                                style={{
                                    margin: 0,
                                    padding: '0.5rem 1rem',
                                }}
                            >
                                <Col>
                                    <Button
                                        type="primary"
                                        color="gold"
                                        onClick={print}
                                    >
                                        {localize('button.print', props.translations)}
                                    </Button>
                                </Col>
                                <Col>
                                    <Button onClick={closeModal}>
                                        {localize('button.close', props.translations)}
                                    </Button>
                                </Col>
                            </Row>
                        ),
                        width: '100%',
                    });
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            {isMobile ? (
                <Button
                    type="primary"
                    color="gold"
                    onClick={openModal}
                >
                    {localize('button.print-form', props.translations)}
                </Button>
            ) : (
                <Button
                    type={props.tableModal ? 'default' : 'primary'}
                    color={props.tableModal ? 'borderless' : 'gold'}
                    onClick={openModal}
                    loading={loading}
                    icon={props.icon}
                >
                    {props.tableModal
                        ? localize('button.information', props.translations)
                        : localize('button.print-form', props.translations)}
                </Button>
            )}
        </>
    );
};

export default PrintForm2;
